import Link from 'next/link'

import styles from './index.module.scss'

import type { NavItemChild } from '../types'
import { formatMainLink } from '@/src/lib/link'

type NavItemListProps = {
  items: NavItemChild[]
  onNavigate?: () => void
}

export default function NavItemList({ items, onNavigate }: NavItemListProps) {
  if (!items.length) return null

  return (
    <ul className={styles.list}>
      {items.map((item, index) => {
        const label = item.label?.trim()
        if (!label) return null

        return (
          <li key={`${label}-${index}`} className={styles.item}>
            <Link
              href={formatMainLink(item.link.path)}
              target="_blank"
              className={styles.link}
              onClick={onNavigate}
            >
              <span className={styles.label}>{label}</span>
              {item.desc ? <span className={styles.description}>{item.desc}</span> : null}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
